//Built-in libraries
import type { ColumnDef } from '@tanstack/react-table';

//Third party libraries
import { useLocation, useNavigate } from 'react-router';
//Custom components
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
import Table from '@/components/UI/Table';
import { useApplicationsListContext } from '@/features/ApplicationForm/Components/ApplicationsList/ApplicationsListProvider';
//Services
import { convertEnumToText } from '@/utils';
import { BFIPFiltersForm } from './BFIPFiltersForm';

//STP Libraries

import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/constants';
import { getSourceTotalCost } from '@/features/ApplicationForm/FormConfig/BFIP/BFIPDashboard';
//Assets and Miscellaneous
import Styles from './styles.module.css';

//Component Begin

export const BFIPApplicationsList = () => {
  const { data, tablePagination, showFilterModal, toggleFilterModal, applyFiltersHandler } = useApplicationsListContext();

  const navigate = useNavigate();
  const location = useLocation();

  const tableColumns: ColumnDef<any>[] = [
    {
      id: 'fullName',
      header: 'Applicant Name',
      accessorKey: 'applicationData',
      size: 250,
      cell: (props) => {
        const { getValue } = props;
        const applicationData = getValue() as any;
        const applicationInformation = applicationData?.applicantInformation;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>{applicationInformation?.fullName}</span>
            <span className='text-xs text-neutralColor-normal'>{applicationInformation?.contactEmail}</span>
          </div>
        );
      },
    },
    {
      id: 'client',
      header: 'Client',
      accessorKey: 'applicationData',
      size: 250,
      cell: (props) => {
        const { getValue } = props;
        const applicationData = getValue() as any;
        const projectDetails = applicationData?.step1?.section1;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>{projectDetails?.buildingOwners?.map((owner: any) => ` ${owner?.name},`)}</span>
            <span className='text-xs text-neutralColor-normal'>
              {projectDetails?.streetAddress}, {projectDetails?.state}, {projectDetails?.zipCode}
            </span>
          </div>
        );
      },
    },
    {
      id: 'amountRequested',
      header: 'Amount Requested',
      accessorKey: 'applicationData',
      size: 200,
      cell: (props) => {
        const { getValue } = props;
        const applicationData = getValue() as any;
        const proposedFinancing = applicationData?.step3?.section2;
        const source = proposedFinancing?.find((f: any) => f?.source === 'Façade Program Assistance');
        const totalCost = getSourceTotalCost(source);
        return (
          <div className='flex flex-col gap-1'>
            <CurrencyFormatDisplay value={totalCost} prefix='$' />
          </div>
        );
      },
    },
    // {
    //   id: 'acquisitionType',
    //   header: 'Project Overview',
    //   accessorKey: 'applicationData.projectDetails.acquisitionType',
    //   size: 200,
    // },
    // {
    //   id: 'constructionType',
    //   header: 'Economic Overview',
    //   accessorKey: 'applicationData.projectDetails.constructionType',
    //   size: 200,
    // },
    {
      id: 'status',
      header: 'Status',
      accessorKey: 'status',
      size: 250,
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='flex items-center w-full capitalize'>
            <span className={`${Styles[getValue() as string]}`}>{convertEnumToText(getValue() as string)}</span>
          </div>
        );
      },
    },
    {
      id: 'createdAt',
      header: 'Submitted',
      accessorKey: 'createdAt',
      size: 250,
      cell: (props) => {
        const { getValue } = props;
        return <div className='flex items-center w-full capitalize'>{dayjs(getValue() as string).format(DATE_FORMAT)}</div>;
      },
    },
  ];

  return (
    <>
      <Table
        cols={tableColumns}
        tableData={data?.data}
        onRowClick={(row: any) => navigate(`${location.pathname}/${row.id}`)}
        pagination={tablePagination}
      />

      {showFilterModal && <BFIPFiltersForm handleModal={toggleFilterModal} handleApplyFilter={applyFiltersHandler} />}
    </>
  );
};
